<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <v-row>
            <v-col cols="12" md="6">
              <div style="margin-bottom: 20px">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['text-color']"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field v-model="fields['text-color']" label="Title Color" />
                  <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="head"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['card-container']"
                      @change="handleChangeCardContainer"
                    />
                    <v-text-field v-model="fields['card-container']" label="Background Color" />
                    <v-btn @click="handleResetCardContainer" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <label class="label-input">Content</label>
          <v-text-field v-model="fields['card-title']" label="Title" />
          <div class="mt-4">
            <label class="label-input">Pagination Colors</label>
            <v-row class="">
              <v-col cols="12" md="6">
                <div style="margin-bottom: 20px">
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="pagination-active-color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields['pagination-active-color']"
                        @change="handleChangePaginationActiveColor"
                      />
                      <v-text-field v-model="fields['pagination-active-color']" label="Pagination Active Color" />
                      <v-btn @click="handleResetPaginationActiveColor" small text color="primary"> Reset </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div style="margin-bottom: 20px">
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="pagination-inactive-color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields['pagination-inactive-color']"
                        @change="handleChangePaginationInactiveColor"
                      />
                      <v-text-field v-model="fields['pagination-inactive-color']" label="Pagination Inactive Color" />
                      <v-btn @click="handleResetPaginationInactiveColor" small text color="primary"> Reset </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- Slides Per View -->
          <div class="mb-4">
            <label class="label-input">Slides Per View</label>
            <p class="text-caption">The viewport is based on the description’s width, not the window’s width.</p>
            <v-row>
              <v-col cols="12" md="4">
                <div>
                  <v-text-field
                    v-model.number="fields.breakpoints.mobile.slidesPerView"
                    label="Mobile"
                    type="number"
                    :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <v-text-field
                    v-model.number="fields.breakpoints.tablet.slidesPerView"
                    label="Tablet"
                    type="number"
                    :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <v-text-field
                    v-model.number="fields.breakpoints.desktop.slidesPerView"
                    label="Desktop"
                    type="number"
                    :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </div>
          <div>
            <div class="d-flex justify-space-between align-center">
              <label class="label-input mb-6">Carousel Items</label>
              <v-btn small text color="primary" @click="handleAddItem">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Item</span>
              </v-btn>
            </div>
            <v-row class="">
              <v-col cols="12" md="6">
                <div style="margin-bottom: 20px">
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="head"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields['text-item-color']"
                        @change="handleChangeTextItemColor"
                      />
                      <v-text-field v-model="fields['text-item-color']" label="Text Item Color" />
                      <v-btn @click="handleResetTextItemColor" small text color="primary"> Reset </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div style="margin-bottom: 20px">
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="head"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields['background-item-color']"
                        @change="handleChangeBackgroundItemColor"
                      />
                      <v-text-field v-model="fields['background-item-color']" label="Background Item Color" />
                      <v-btn @click="handleResetBackgroundItemColor" small text color="primary"> Reset </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields['list-item']" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Item {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="wrap-product-form">
                    <ckeditor :editor="editor" v-model="item['content']" :config="editorConfig" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'text-carousel-section-editor',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        'card-container': '',
        'text-item-color': '#000000',
        'background-item-color': '#ffffff',
        'pagination-active-color': '#000000',
        'pagination-inactive-color': '#cccccc',
        'card-title': '',
        breakpoints: {
          mobile: {
            slidesPerView: 1,
          },
          tablet: {
            slidesPerView: 1,
          },
          desktop: {
            slidesPerView: 3,
          },
        },
        'list-item': [],
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleAddItem() {
      this.fields['list-item'].push({
        content: '',
      });
    },
    handleRemoveItem(index) {
      this.fields['list-item'].splice(index, 1);
    },
    handleChangeCardContainer(e) {
      this.fields['card-container'] = e.target.value;
    },
    handleResetCardContainer() {
      this.fields['card-container'] = '';
    },
    handleChangeTextItemColor(e) {
      this.fields['text-item-color'] = e.target.value;
    },
    handleResetTextItemColor() {
      this.fields['text-item-color'] = '#000000';
    },
    handleChangeBackgroundItemColor(e) {
      this.fields['background-item-color'] = e.target.value;
    },
    handleResetBackgroundItemColor() {
      this.fields['background-item-color'] = '#ffffff';
    },
    handleChangeTextColor(e) {
      this.fields['text-color'] = e.target.value;
    },
    handleResetTextColor() {
      this.fields['text-color'] = '';
    },
    handleChangePaginationActiveColor(e) {
      this.fields['pagination-active-color'] = e.target.value;
    },
    handleResetPaginationActiveColor() {
      this.fields['pagination-active-color'] = '#000000';
    },
    handleChangePaginationInactiveColor(e) {
      this.fields['pagination-inactive-color'] = e.target.value;
    },
    handleResetPaginationInactiveColor() {
      this.fields['pagination-inactive-color'] = '#cccccc';
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionTextCarousel(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 300px;
}

.ck-editor__editable {
  min-height: 300px;
}

.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}

.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}

.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
